export default class Tabs {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Tabs;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;
		
		$(document).on('click', '.tabs-nav .tab', function(e) {
			e.preventDefault();
			var $clickedTab = $(this),
				$tabsContainer = $(this).closest('.tabs-container');
				$('.tab',$tabsContainer).removeClass('is-active');
				$clickedTab.addClass('is-active');
				
			$('.tab-content',$tabsContainer).fadeOut(500).promise().done(function() {
				$(this).removeClass('show');
				$($clickedTab.attr('href')).fadeIn(500, function() {
					$(this).addClass('show');
				});
			});
		});
	}

	something() {
		const self = this;

		// do some code here
	}
}